<template>
  <div id='page'>
    <div v-if='career.total.length > 0'>
      <div class='section-title'>{{ $t("playerCareerStats.regularSeasonData") }}</div>
      <careerStatsTitle/>
      <div v-for="(item, index) in career.total" :key="index">
        <careerStatsCell :careerStats='item'/>
        <hr v-if='index != career.total.length - 1'/>
      </div>
    </div>

    <div v-if='career.totalAvg.length > 0'>
      <div class='section-title'>{{ $t("playerCareerStats.regularAvgSeasonData") }}</div>
      <careerStatsTitle/>
      <div v-for="(item, index) in career.totalAvg" :key="index">
        <careerStatsCell :careerStats='item'/>
        <hr v-if='index != career.totalAvg.length - 1'/>
      </div>
    </div>

    <div v-if='career.playoff.length > 0'>
      <div class='section-title'>{{ $t("playerCareerStats.playoffStatistics") }}</div>
      <careerStatsTitle/>
      <div v-for="(item, index) in career.playoff" :key="index">
        <careerStatsCell :careerStats='item'/>
        <hr v-if='index != career.playoff.length - 1'/>
      </div>
    </div>

    <div v-if='career.playoffAvg.length > 0'>
      <div class='section-title'>{{ $t("playerCareerStats.playoffAvgStatistics") }}</div>
      <careerStatsTitle/>
      <div v-for="(item, index) in career.playoffAvg" :key="index">
        <careerStatsCell :careerStats='item'/>
        <hr v-if='index != career.playoffAvg.length - 1'/>
      </div>
    </div>

    <hr v-if='netState == 0'/>
    <loadStateView :state='netState' :refreshHandle="loadData"/>
  </div>
</template>

<script>
import careerStatsTitle from './components/careerStatsTitle'
import careerStatsCell from './components/careerStatsCell'
import { checkEmptyObject } from '@/utils'

export default {
  name: 'player-career-stats',
  props: {
    playerId: {
      type: String,
      required: true
    }
  },
  components: {
    careerStatsTitle,
    careerStatsCell
  },
  data () {
    return {
      career: {
        total: [], // 常规赛
        totalAvg: [], // 常规赛平均数据
        playoff: [], // 季后赛
        playoffAvg: [] // 季后赛平均数据
      }
    }
  },
  activated () {
    this.loadData()
  },
  watch: {
    playerId (newValue, oldValue) {
      if (newValue !== oldValue) {
        this.loadData()
      }
    }
  },
  methods: {
    loadData () {
      this.netState = checkEmptyObject(this.career) ? 1 : 0
      this.$dataBaseClient.get(`b_player/careerData?playerId=${this.playerId}`)
        .then((response) => {
          this.netState = response.netState

          if (this.netState === 3) {
            this.career.total = []
            this.career.totalAvg = []
            this.career.playoff = []
            this.career.playoffAvg = []
            return
          }

          console.log(response)
          this.career = response
        })
        .catch((error) => {
          this.netState = 2
          console.log(error)
        })
    }
  }
}
</script>

<style lang="sass" scoped>
@import styles
</style>
